import {
  ComputedStaticTextInput,
  IComputedStaticTextInputProps,
} from '@framework/form';
import React from 'react';
import { ConfigFormItem } from '../../../../../../../ui/form/ConfigFormItem';
import { ComputeExpression } from '../../../../../../expressions/compute/ComputeExpression';
import { useNumberExpressionValue } from '../../../../computed';

export interface IComputedNumberPaymentRowFieldProps {
  name: string;
  label: string;
  help?: string;
  readonly: boolean;
  expression: ComputeExpression;
  format?: IComputedStaticTextInputProps<number | null>['format'];
}

/**
 * Componente di renderizzazione di un campo di tipo numero calcolato
 * per la voce dic osto
 */
export function ComputedNumberPaymentRowField(
  props: IComputedNumberPaymentRowFieldProps,
) {
  const { name, label, help, readonly, expression, format } = props;

  const value = useNumberExpressionValue(name, expression);

  return (
    <ConfigFormItem name={name} label={label} help={help} readonly={readonly}>
      <ComputedStaticTextInput
        name={name}
        value={value}
        readonly={readonly}
        removeBorder
        format={format}
      />
    </ConfigFormItem>
  );
}
